/* Romantico reveal primitive. FROZEN LAYER (BUILD-CONTRACT.md, section 2.4).
   Observes .rom-reveal elements and adds .is-visible on intersection.
   Honors prefers-reduced-motion and the global Romantico motion setting
   (--rom-motion-scale: 0 means motion is off). */
(function () {
  if (window.RomReveal) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function motionOff() {
    const scale = getComputedStyle(document.documentElement).getPropertyValue('--rom-motion-scale');
    return parseFloat(scale) === 0;
  }

  let observer;

  function show(el) {
    el.classList.add('is-visible');
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const items = scope.querySelectorAll('.rom-reveal:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion.matches || motionOff() || !('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }

    observer =
      observer ||
      new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              show(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px' }
      );

    items.forEach((el) => observer.observe(el));
  }

  window.RomReveal = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
